module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap personal-wrap collection-wrap"
  }, [(_vm.loadShow) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.loadShow,
      "loadingText": "拼命加载中"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.listPageGoodsFav.length == 0 && !_vm.loadShow) ? _c('empty', {
    attrs: {
      "imgpath": "/static/images/empty_collection_3x.png",
      "emptytext": "您还没有收藏商品",
      "btntext": "去逛一逛",
      "btnurl": "/main/home"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.listPageGoodsFav.length != 0 && !_vm.loadShow),
      expression: "listPageGoodsFav.length!=0 && !loadShow"
    }],
    staticClass: "flex-column"
  }, [_c('div', {
    staticClass: "grid-tip"
  }, [_vm._v("\n      你收藏了\n      "), _c('label', {
    staticClass: "primary"
  }, [_vm._v(_vm._s(_vm.size) + " ")]), _vm._v("个商品\n      "), (!_vm.editstate) ? _c('label', {
    staticClass: "fr blue",
    on: {
      "click": function($event) {
        _vm.editstate = true
      }
    }
  }, [_vm._v("编辑")]) : _c('label', {
    staticClass: "fr blue",
    on: {
      "click": function($event) {
        _vm.editstate = false
      }
    }
  }, [_vm._v("完成")])]), _vm._v(" "), _c('div', {
    staticClass: "collection-list flex-item",
    class: [_vm.editstate ? 'edit-state' : ' ']
  }, [_c('mu-list', _vm._l((_vm.listPageGoodsFav), function(pageGoodsShow, indexNumber) {
    return _c('myOrdersItem', {
      key: indexNumber,
      attrs: {
        "width": 150,
        "height": 150,
        "cartitem": pageGoodsShow,
        "selvalue": _vm.checkboxsel,
        "isCheckBox": 'true',
        "isRightTriggle": 'true'
      },
      on: {
        "on-result-change": _vm.onResultChange
      }
    })
  }), 1), _vm._v(" "), _c('mu-infinite-scroll', {
    attrs: {
      "scroller": _vm.scroller,
      "loading": _vm.loading,
      "loadingText": ""
    },
    on: {
      "load": _vm.loadMore
    }
  }), _vm._v(" "), ((_vm.lastPageNo == _vm.currentPage && !_vm.loadShow) || (_vm.size == 0 && !_vm.loadShow)) ? _c('p', {
    staticClass: "none-goods"
  }, [_vm._v("没有更多商品啦~")]) : _vm._e()], 1), _vm._v(" "), (_vm.editstate) ? _c('div', {
    staticClass: "cartBottom"
  }, [_c('mu-checkbox', {
    staticClass: "list-radio",
    attrs: {
      "name": "group",
      "id": "all",
      "label": "全选"
    },
    on: {
      "change": function($event) {
        return _vm.selectAll($event)
      }
    },
    model: {
      value: (_vm.allChecked),
      callback: function($$v) {
        _vm.allChecked = $$v
      },
      expression: "allChecked"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "go",
    class: [_vm.checkboxsel.length == 0 ? 'disabledbtn' : 'primarybtn'],
    on: {
      "click": _vm.deleteItem
    }
  }, [_vm._v("取消收藏")])], 1) : _vm._e()]), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.isDelete,
      "title": "取消收藏",
      "titleClass": "dialogTitle",
      "bodyClass": "dialogBody",
      "actionsContainerClass": "dialogActionsContainer"
    },
    on: {
      "close": function($event) {
        _vm.isDelete = false;
      }
    }
  }, [_vm._v("\n    确定对选中的" + _vm._s(_vm.checkboxsel.length) + "个产品取消收藏？\n    "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "否"
    },
    on: {
      "click": function($event) {
        _vm.isDelete = false
      }
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "确定"
    },
    on: {
      "click": function($event) {
        return _vm.closedeleteAddress()
      }
    },
    slot: "actions"
  })], 1), _vm._v(" "), (_vm.toast1) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": "当前还没有选中商品"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toast2) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": "删除成功!"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-efcdcfa0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/personal/mycollection.vue
// module id = 420
// module chunks = 68